import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "table-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex gap-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useVesselClass } from "@/stores/master/vessel-class";
import { hasAccess } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListVesselClass',
  setup(__props) {

const linkAdd = {
  text: "Add Vessel Class",
  url: "/master/vessel-class/create",
};

const headers: Header[] = [
  { text: "NAME", value: "name" },
  { text: "CODE", value: "code" },
  { text: "YEAR", value: "year" },
  { text: "HEAD OFFICE", value: "head_office" },
  { text: "IACS MEMBER", value: "iacs_member" },
  { text: "ACTIONS", value: "action" },
];

const vesselClassStore = useVesselClass();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listRole = ref<any>([]);
const isLoading = ref(false);

const loadDataVesselClass = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await vesselClassStore.dispatchGetAll(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listRole.value = await vesselClassStore.vesselClassList.items;
    page.value = await vesselClassStore.vesselClassList.page;
    limit.value = await vesselClassStore.vesselClassList.pageSize;
    totalItems.value = await vesselClassStore.vesselClassList.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataVesselClass();
};

const handleEdit = (vesselType: any) => {
  router.push("/master/vessel-class/" + vesselType);
};

const handleDelete = async (vesselType: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${vesselType.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await vesselClassStore.dispatchDelete(
          vesselType.id
        );
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataVesselClass();
        } else {
          toast.error(message);
        }
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataVesselClass();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "List Data Vessel Class")
      ], -1)),
      _createVNode(FilterTable, {
        link: linkAdd,
        onSearchByQuery: loadDataVesselClass
      }),
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(BaseLoading, { key: 0 }))
          : _createCommentVNode("", true),
        (!isLoading.value)
          ? (_openBlock(), _createBlock(_unref(EasyDataTable), {
              key: 1,
              headers: headers,
              items: listRole.value,
              "show-index": "",
              "server-options": {
            page: page.value,
            rowsPerPage: limit.value,
          },
              "server-items-length": totalItems.value,
              "onUpdate:serverOptions": handleServerOptionsUpdate,
              "buttons-pagination": ""
            }, {
              "item-iacs_member": _withCtx((props) => [
                (props.iacs_member == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
                      _createElementVNode("span", { class: "badge bg-primary" }, "Yes", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
                      _createElementVNode("span", { class: "badge bg-danger" }, "No", -1)
                    ])))
              ]),
              "item-action": _withCtx((props) => [
                _createElementVNode("div", _hoisted_6, [
                  (_unref(hasAccess)('vessel_class-update'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info btn-sm text-white",
                        onClick: ($event: any) => (handleEdit(props.id))
                      }, " Edit ", 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (_unref(hasAccess)('vessel_class-delete'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-danger btn-sm",
                        onClick: ($event: any) => (handleDelete(props))
                      }, " Delete ", 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["items", "server-options", "server-items-length"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})